var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoteEditor = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.779,
    height: 14.09,
    viewBox: "0 0 11.779 14.09",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M729.228-45.361h-1.541V-46.9a.55.55,0,0,0-.551-.55H718.55a.55.55,0,0,0-.55.55V-36a.55.55,0,0,0,.55.55h1.541v1.541h0a.551.551,0,0,0,.554.549h8.583a.55.55,0,0,0,.55-.55v-10.9A.55.55,0,0,0,729.228-45.361ZM719.1-36.555v-9.8h7.485v9.8Zm9.577,2.092h-4.531l3.152-1.015a.554.554,0,0,0,.389-.533v-8.249h.991ZM725.6-44.178a.55.55,0,0,1-.55.55h-4.4a.55.55,0,0,1-.55-.55.55.55,0,0,1,.55-.55h4.4A.55.55,0,0,1,725.6-44.178Zm0,2.725a.55.55,0,0,1-.55.55h-4.4a.55.55,0,0,1-.55-.55.55.55,0,0,1,.55-.55h4.4A.55.55,0,0,1,725.6-41.454Zm0,2.725a.55.55,0,0,1-.55.55h-4.4a.55.55,0,0,1-.55-.55.55.55,0,0,1,.55-.55h4.4A.55.55,0,0,1,725.6-38.729Z",
    transform: "translate(-718 47.453)",
    fill: "#727272"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoteEditor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/note-editor.f9c4fc4115e921e422c7e3a3cc07be06.svg";